export const iconFontAwesomeSportsFitnessPersonSkiing = (
	<i className="fa-solid fa-person-skiing"></i>
);
